var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics"},[_c('div',{staticClass:"stat"},[_c('span',{staticClass:"stat-label"},[_vm._v("Pain level: ")]),_c('span',{staticClass:"stat-stat"},[_vm._v(_vm._s(_vm.existingEntry.data.painLevel / 10))])])])}
var staticRenderFns = []

export { render, staticRenderFns }